export enum AuditLogEventType {
  LoginFailed = "login-failed",
  AccountActivity = "account-activity",
  Generic = "generic",
}